// Module
var code = "<template>\n  <div style=\"padding: 0; margin: 0\">\n    <pre>\n      <code>\n        ${data | jsonString}\n      </code>\n    </pre>\n  </div>\n</template>\n";
// Exports
export default code;